import type User from '@/models/user';

type CreatorAdvisorUser = Pick<User, 'profile_type'> | { profile_type?: string | null };

/** True when the user is a creator or advisor (Performance dashboard access). */
export function isCreatorOrAdvisor(user: CreatorAdvisorUser | null | undefined): boolean {
  const type = user?.profile_type;
  return type === 'creator' || type === 'advisor';
}
